import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from 'library/common-styles';

export const nonDocumentFieldStyles = (theme: ThemeType) => ({
    referenceItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    contentType: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
    nonDocumentFieldContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
});
